import { en } from './en'
import { fr } from './fr'

export const activityPage = {
  en,
  fr
}